// Draws the collection filter panel and grid from the catalogue index.
// Shopify Search and Discovery is off, so collection.filters gives Liquid nothing to build from.
(function () {
  'use strict';

  const CONFIG = window.SACatalogConfig || {};
  const PENDING_CLASS = 'sa-catalog-pending';
  const TYPING_DELAY = 500;

  const ICON_PLUS =
    "<svg xmlns='http://www.w3.org/2000/svg' class='plus' width='16' height='16' viewBox='0 0 16 16' fill='none'>" +
    '<path d="M2.5 8H13.5" stroke="#949494" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M8 2.5V13.5" stroke="#949494" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ICON_MINUS =
    "<svg xmlns='http://www.w3.org/2000/svg' class='minus' width='16' height='16' viewBox='0 0 16 16' fill='none'>" +
    '<path d="M2.5 8H13.5" stroke="#949494" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ICON_CLOSE =
    "<span class='svg-wrapper'><svg xmlns='http://www.w3.org/2000/svg' width='10' height='11' viewBox='0 0 10 11' fill='none'>" +
    '<path d="M7.8125 2.6875L2.1875 8.3125" stroke="#949494" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M7.8125 8.3125L2.1875 2.6875" stroke="#949494" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg></span>';
  const BRIGHTNESS_RINGS =
    "<svg xmlns='http://www.w3.org/2000/svg' width='71' height='72' viewBox='0 0 71 72' fill='none'>" +
    [33, 27, 21, 15, 9]
      .map(function (radius, at) {
        return (
          "<circle cx='35.1992' cy='36' r='" + radius + "' stroke='#949494' stroke-width='2'" +
          " class='brightness-circle' data-level='" + (5 - at) + "'/>"
        );
      })
      .join('') +
    '</svg>';

  // Colours come from the old snippets/filter-product-variables.liquid.
  const TEMPERATURE_CHIPS = {
    '2000K': 'background-color: #FFCA7E;',
    '2400K': 'background-color: #F5FF48;',
    '2700K': 'background-color: #F6FE75;',
    '3000K': 'background-color: #FCFECF;',
    '4000K': 'background-color: #F2F2F2;',
    '5000K': 'background-color: #DAF7FF;',
    '5700K': 'background-color: #CAF4FF;',
    '6000K': 'background-color: #C3F2FF;',
    '6500K': 'background-color: #B8F0FF;',
    'Tuneable White': 'background: linear-gradient(90deg, #FCFECF 0%, #F2F2F2 50%, #B8F0FF 100%);'
  };

  // Cone icons from the old snippets/filter-product-variables.liquid, narrowest first.
  function cone(body, width, clip) {
    const id = 'sa-cone-' + clip;
    return (
      "<svg xmlns='http://www.w3.org/2000/svg' width='" + width + "' height='20' viewBox='0 0 " +
      width + " 20' fill='none'>" +
      (clip ? "<g clip-path='url(#" + id + ")'>" : '') + body + (clip ? '</g>' : '') +
      (clip ? "<defs><clipPath id='" + id + "'><rect width='" + width + "' height='20' fill='white'/></clipPath></defs>" : '') +
      '</svg>'
    );
  }

  const BEAM_BANDS = [
    { key: 'to-15', label: '< 15°', max: 15, icon: cone('<path d="M10 0L14 20H6L10 0Z" fill="#4A4A4A"/>', 20, 0) },
    { key: '16-30', label: '16 - 30°', min: 16, max: 30, icon: cone('<path d="M7 0L14 20H0L7 0Z" fill="#4A4A4A"/>', 14, 0) },
    { key: '31-49', label: '31 - 49°', min: 31, max: 49, icon: cone('<path d="M10 0L20 20H0L10 0Z" fill="#4A4A4A"/>', 20, 3) },
    { key: '50-70', label: '50 - 70°', min: 50, max: 70, icon: cone('<path fill-rule="evenodd" clip-rule="evenodd" d="M-10 20L10 0L30 20H-10Z" fill="#4A4A4A"/>', 20, 4) },
    { key: 'from-71', label: '> 71°', min: 71, icon: cone('<rect x="-11.7588" y="-23.6855" width="43.6859" height="43.6859" fill="#4A4A4A"/>', 20, 5) },
    { key: 'asymmetrical', label: 'Asymmetrical', specs: ['beam_angle', 'spec_beam_angle'], contains: 'asymmetric', icon: cone('<path d="M20.084 12.5V20H0.0839844L6.08398 0L20.084 12.5Z" fill="#4A4A4A"/>', 20, 6) }
  ];

  // Keyed by the name the merchant types into the section block's Filter Reference setting.
  const GROUPS = {
    'beam angle': {
      handle: 'beam-angle',
      title: 'Beam Angle',
      facet: 'beam_angle',
      rangeKey: 'beam_angle',
      bands: BEAM_BANDS,
      labelClass: 'beam-angle'
    },
    'colour temperature': {
      handle: 'colour-temperature',
      title: 'Colour Temperature',
      facet: 'colour_temperature',
      chip: 'temperature',
      labelClass: 'colour-temperature'
    },
    brightness: { handle: 'brightness', title: 'Brightness', brightness: 'lumens', unit: 'LM' },
    finish: {
      handle: 'finish',
      title: 'Finish',
      facet: 'finish',
      chip: 'image',
      /*
        A two tone finish is its own finish with its own swatch, so it keeps its own row.
        Every other list splits, because a fitting switchable to 4000K is a 4000K fitting.
      */
      combined: true,
      labelClass: 'finish',
      // .filter-items ul li.finish is what makes the swatch row tall enough.
      itemClass: 'finish'
    },
    'ip rating': { handle: 'ip-rating', title: 'IP Rating', facet: 'ip_rating' },
    // Dimensions is three sibling headings, the way filter-dimensions-custom.liquid built them.
    dimensions: {
      siblings: [
        { handle: 'cut_out', title: 'Cut Out', rows: [{ key: 'cut_out', label: 'Cut Out', unit: 'MM', icon: 'cut_out' }] },
        { handle: 'watt', title: 'Watts', rows: [{ key: 'watt', label: 'Watts', unit: 'W', icon: 'watts' }] },
        {
          handle: 'dimensions',
          title: 'Dimensions',
          rows: [
            { key: 'diameter', label: 'Diameter', unit: 'MM', icon: 'diameter' },
            { key: 'depth', label: 'Depth', unit: 'MM', icon: 'depth' },
            { key: 'length', label: 'Length', unit: 'MM', icon: 'length' },
            { key: 'width', label: 'Width', unit: 'MM', icon: 'width' }
          ]
        }
      ]
    }
  };

  const DEFAULT_ORDER = 'beam angle,colour temperature,brightness,finish,dimensions,ip rating';

  const BANDED = {};
  const COMBINED = {};
  Object.keys(GROUPS).forEach((ref) => {
    const group = GROUPS[ref];
    if (group.bands) {
      BANDED[group.facet] = group;
    }
    if (group.combined) {
      COMBINED[group.facet] = group;
    }
  });

  // Older links carry Search and Discovery names. Keys come from the app's api/lib/catalog/facets.js.
  const LEGACY_RANGES = {
    watt_min: ['watt', 'min'],
    watt_max_2: ['watt', 'max'],
    lumens_min: ['lumens', 'min'],
    lumens_max: ['lumens', 'max'],
    cut_out_min: ['cut_out', 'min'],
    cut_out_max: ['cut_out', 'max'],
    filter_diameter: ['diameter', 'min'],
    filter_depth: ['depth', 'min'],
    filter_length: ['length', 'min'],
    filter_width: ['width', 'min'],
    filter_height: ['height', 'min'],
    beam_angle: ['beam_angle', 'min']
  };
  const LEGACY_LISTS = {
    finish: 'finish',
    ip_rating: 'ip_rating',
    filter_colour_temperature: 'colour_temperature',
    collection_main_tag: 'collection_main_tag',
    collection_sub_tag: 'collection_sub_tag',
    collection_sub_sub_tag: 'collection_sub_sub_tag',
    dimming_control: 'dimming_control',
    material: 'material',
    tier: 'tier',
    finder_space_style: 'space_style'
  };

  let index = null;
  let engine = null;
  let loader = null;
  let serverGrid = null;
  let serverList = null;
  let featured = [];
  let typingTimer = null;
  let groupsStale = false;
  const DEFAULT_SORT = 'title-ascending';
  let state = { lists: {}, ranges: {}, bands: {}, page: 1, sort: null };
  let serverPaging = null;
  let serverCount = null;

  const escapeHtml = (value) => window.SACatalogCard.escapeHtml(value);
  const slug = (value) => window.SACatalogIndex.slug(value);

  function el(selector) {
    return document.querySelector(selector);
  }

  // ---------------------------------------------------------------- url state

  function hasFilterParams(search) {
    const params = new URLSearchParams(search);
    for (const key of params.keys()) {
      if (key.indexOf('f.') === 0 || key.indexOf('filter.') === 0) {
        return true;
      }
    }
    return false;
  }

  function parseBounds(raw) {
    const parts = String(raw).split('-');
    const min = parts[0] === '' || parts[0] === undefined ? null : Number(parts[0]);
    const max = parts[1] === '' || parts[1] === undefined ? null : Number(parts[1]);
    return {
      min: min === null || isNaN(min) ? null : min,
      max: max === null || isNaN(max) ? null : max
    };
  }

  function boundsFor(ranges, key) {
    if (!ranges[key]) {
      ranges[key] = { min: null, max: null };
    }
    return ranges[key];
  }

  function readState(search) {
    const params = new URLSearchParams(search);
    const next = { lists: {}, ranges: {}, bands: {}, page: 1, sort: DEFAULT_SORT };
    const isRange = (key) => index.rangeAt[key] !== undefined;

    params.forEach((value, key) => {
      if (key === 'page') {
        const page = parseInt(value, 10);
        next.page = page > 0 ? page : 1;
        return;
      }
      if (key === 'sort' || key === 'sort_by') {
        next.sort = value;
        return;
      }
      if (key.indexOf('f.') === 0) {
        const name = key.slice(2);
        if (BANDED[name]) {
          const picked = next.bands[name] || new Set();
          value.split(',').forEach((entry) => {
            if (entry !== '') {
              picked.add(entry);
            }
          });
          next.bands[name] = picked;
          return;
        }
        if (isRange(name)) {
          next.ranges[name] = parseBounds(value);
        } else {
          const picked = next.lists[name] || new Set();
          value.split(',').forEach((entry) => {
            if (entry !== '') {
              picked.add(entry);
            }
          });
          next.lists[name] = picked;
        }
        return;
      }
      if (key.indexOf('filter.p.m.custom.') === 0) {
        const name = key.slice('filter.p.m.custom.'.length);
        if (LEGACY_RANGES[name]) {
          const target = LEGACY_RANGES[name];
          const number = Number(value);
          if (!isNaN(number)) {
            boundsFor(next.ranges, target[0])[target[1]] = number;
          }
          return;
        }
        const facetKey = LEGACY_LISTS[name];
        if (facetKey) {
          const picked = next.lists[facetKey] || new Set();
          picked.add(slug(value));
          next.lists[facetKey] = picked;
        }
      }
    });

    Object.keys(next.ranges).forEach((key) => {
      const bounds = next.ranges[key];
      if (bounds.min === null && bounds.max === null) {
        delete next.ranges[key];
      }
    });
    Object.keys(next.lists).forEach((key) => {
      if (next.lists[key].size === 0) {
        delete next.lists[key];
      }
    });
    Object.keys(next.bands).forEach((key) => {
      if (next.bands[key].size === 0) {
        delete next.bands[key];
      }
    });
    return next;
  }

  function stateToSearch() {
    const params = new URLSearchParams();
    Object.keys(state.lists)
      .sort()
      .forEach((key) => {
        const picked = Array.from(state.lists[key]).sort();
        if (picked.length > 0) {
          params.set('f.' + key, picked.join(','));
        }
      });
    Object.keys(state.bands)
      .sort()
      .forEach((key) => {
        const picked = Array.from(state.bands[key]);
        if (picked.length > 0) {
          params.set('f.' + key, picked.join(','));
        }
      });
    Object.keys(state.ranges)
      .sort()
      .forEach((key) => {
        const bounds = state.ranges[key];
        if (bounds.min === null && bounds.max === null) {
          return;
        }
        params.set('f.' + key, (bounds.min === null ? '' : bounds.min) + '-' + (bounds.max === null ? '' : bounds.max));
      });
    if (state.sort && state.sort !== DEFAULT_SORT) {
      params.set('sort', state.sort);
    }
    if (state.page > 1) {
      params.set('page', String(state.page));
    }
    const search = params.toString();
    return window.location.pathname + (search === '' ? '' : '?' + search);
  }

  function isFiltered() {
    return (
      Object.keys(state.lists).length > 0 ||
      Object.keys(state.ranges).length > 0 ||
      Object.keys(state.bands).length > 0
    );
  }

  function appliedCount() {
    let total = 0;
    Object.keys(state.lists).forEach((key) => {
      total += state.lists[key].size;
    });
    Object.keys(state.bands).forEach((key) => {
      total += state.bands[key].size;
    });
    total += Object.keys(state.ranges).length;
    return total;
  }

  // ---------------------------------------------------------------- querying

  /*
    The collection plus everything its wide query reaches. Counts and results share this one
    scope, so a value's count always matches what picking it gives.
  */
  function scopeOf(query) {
    const wide = CONFIG.wideTags || [];
    query.collection = CONFIG.collection || null;
    query.tags = new Set(wide);
    query.unionScope = wide.length > 0;
    return query;
  }

  // The exact reading is a Watts setting, so every other dimension stays a plain range.
  const EXACT_CAPABLE = ['watt'];

  // Picked rows are kept as their slug, which this turns back into the merchant's text.
  const comboLabelCache = {};
  function comboLabelFor(facetKey, key) {
    if (!comboLabelCache[facetKey]) {
      const map = {};
      engine.allComboLabels(facetKey).forEach((label) => {
        map[slug(label)] = label;
      });
      comboLabelCache[facetKey] = map;
    }
    return comboLabelCache[facetKey][key] || null;
  }

  function splitPicks() {
    const lists = {};
    const combos = {};
    Object.keys(state.lists).forEach((facetKey) => {
      if (!COMBINED[facetKey]) {
        lists[facetKey] = state.lists[facetKey];
        return;
      }
      const labels = new Set();
      state.lists[facetKey].forEach((key) => {
        const label = comboLabelFor(facetKey, key);
        if (label) {
          labels.add(label);
        }
      });
      if (labels.size > 0) {
        combos[facetKey] = labels;
      }
    });
    return { lists: lists, combos: combos };
  }

  function pickedBands() {
    const out = {};
    Object.keys(state.bands).forEach((facetKey) => {
      const group = BANDED[facetKey];
      if (!group) {
        return;
      }
      const chosen = group.bands.filter((band) => state.bands[facetKey].has(band.key));
      if (chosen.length > 0) {
        out[facetKey] = { rangeKey: group.rangeKey, chosen: chosen };
      }
    });
    return out;
  }

  function buildQuery() {
    const picks = splitPicks();
    return scopeOf({
      lists: picks.lists,
      combos: picks.combos,
      ranges: state.ranges,
      bands: pickedBands(),
      exactRangeKeys: new Set(CONFIG.rangeMatch === 'exact' ? EXACT_CAPABLE : [])
    });
  }

  // ---------------------------------------------------------------- panel

  function rangeRow(row, bounds, span) {
    const icon = row.icon ? (CONFIG.icons || {})[row.icon] : null;
    const value = (side) => (bounds && bounds[side] !== null && bounds[side] !== undefined ? bounds[side] : '');
    return (
      "<div class='filter-group__range " + row.key + "' data-key='" + row.key + "'" +
      (span && span.min !== null ? " data-min-value='" + span.min + "'" : '') +
      (span && span.max !== null ? " data-max-value='" + span.max + "'" : '') +
      '>' +
      "<div class='filter-group__range-label'>" +
      (icon
        ? "<span class='filter-group__range-icon'><img src='" + escapeHtml(icon) +
          "' alt='" + escapeHtml(row.label) + "' loading='lazy'></span>"
        : '') +
      "<p class='text-wrapper'>" + escapeHtml(row.label) + '</p>' +
      '</div>' +
      "<div class='filter-group__range-box'>" +
      "<div class='frame-range frame-range--bounded'>" +
      "<div class='text-wrapper text-wrapper--bound'>MIN</div>" +
      "<div class='filter-group__range__wrapper'>" +
      "<input type='text' inputmode='decimal' class='filter-group__range__input min' placeholder='--'" +
      " data-range='" + row.key + "' data-bound='min' value='" + value('min') + "'>" +
      '</div>' +
      "<div class='text-wrapper text-wrapper--bound text-wrapper--max'>MAX</div>" +
      "<div class='filter-group__range__wrapper'>" +
      "<input type='text' inputmode='decimal' class='filter-group__range__input max' placeholder='--'" +
      " data-range='" + row.key + "' data-bound='max' value='" + value('max') + "'>" +
      '</div>' +
      "<div class='text-wrapper'>" + escapeHtml(row.unit) + '</div>' +
      '</div></div></div>'
    );
  }

  // A value naming more than one temperature blends their colours, the way Tuneable White does.
  function temperatureChip(label) {
    if (TEMPERATURE_CHIPS[label]) {
      return TEMPERATURE_CHIPS[label];
    }
    const parts = label.split(',').map((part) => part.trim());
    if (parts.length < 2) {
      return 'background-color: #F2F2F2;';
    }
    const stops = parts.map((part, at) => {
      const own = TEMPERATURE_CHIPS[part] || 'background-color: #F2F2F2;';
      const colour = own.replace('background-color: ', '').replace(';', '');
      return colour + ' ' + Math.round((at / (parts.length - 1)) * 100) + '%';
    });
    return 'background: linear-gradient(90deg, ' + stops.join(', ') + ');';
  }

  function listValueMarkup(group, facetKey, value, position) {
    const inputId = 'Filter-' + facetKey + '-' + position;
    const picked = state.lists[facetKey];
    const active = picked ? picked.has(value.key) : false;
    let inner;

    if (group.chip === 'image') {
      const name = slug(value.label);
      inner =
        "<div class='svg-wrapper'><span><img class='dynamic-img' data-name='" + escapeHtml(name) +
        "' src='" + escapeHtml(index.imageBase + name + '.png') + "' width='58' height='58' alt='" +
        escapeHtml(value.label) + "' loading='lazy'></span><span>" + escapeHtml(value.label) + '</span></div>';
    } else if (group.chip === 'temperature') {
      const style = temperatureChip(value.label);
      inner =
        "<div class='svg-wrapper'><span class='svg-with-bg' style='" + style + "'></span><span>" +
        escapeHtml(value.label) + '</span></div>';
    } else {
      inner =
        "<div class='svg-wrapper'></div>" +
        "<span class='facet-checkbox__text' aria-hidden='true'>" +
        "<span class='facet-checkbox__text-label'>" + escapeHtml(value.label) + '</span></span>';
    }

    return (
      "<li class='" + (group.itemClass ? group.itemClass + ' ' : '') + "list-menu__item facets__item'>" +
      "<label for='" + inputId + "' class='facets__label facet-checkbox" + (active ? ' active' : '') +
      (group.labelClass ? ' ' + group.labelClass : '') + "'>" +
      "<input type='checkbox' id='" + inputId + "' data-facet='" + facetKey + "'" +
      " value='" + escapeHtml(value.key) + "'" + (active ? ' checked' : '') + '>' +
      "<span class='check-mark'></span>" +
      inner +
      '</label></li>'
    );
  }

  function groupShell(handle, title, body, extraClass) {
    if (body === '') {
      return '';
    }
    return (
      "<div class='filter-group " + (extraClass || 'filter-group--' + handle) + " js-filter'" +
      " data-key='" + handle + "'>" +
      "<div class='filter-group__heading'><h4>" + escapeHtml(title) + '</h4>' +
      "<div class='filter-group__arrow'>" + ICON_PLUS + ICON_MINUS + '</div></div>' +
      "<div class='filter-group__items'>" + body + '</div></div>'
    );
  }

  function bandGroupMarkup(group) {
    const query = buildQuery();
    const totals = engine.countBands(query, group.facet, group.rangeKey, group.bands);
    const picked = state.bands[group.facet];
    const items = [];
    group.bands.forEach((band, at) => {
      const active = picked ? picked.has(band.key) : false;
      if (totals[at] === 0 && !active) {
        return;
      }
      const inputId = 'Filter-' + group.facet + '-' + (items.length + 1);
      items.push(
        "<li class='list-menu__item facets__item'>" +
        "<label for='" + inputId + "' class='facets__label facet-checkbox" + (active ? ' active' : '') +
        ' ' + group.labelClass + "'>" +
        "<input type='checkbox' id='" + inputId + "' data-band='" + group.facet + "'" +
        " value='" + escapeHtml(band.key) + "'" + (active ? ' checked' : '') + '>' +
        "<span class='check-mark'></span>" +
        "<div class='svg-wrapper'><span>" + band.icon + '</span><span>' + escapeHtml(band.label) + '</span></div>' +
        '</label></li>'
      );
    });
    if (items.length === 0) {
      return '';
    }
    const body =
      "<div class='filter-items'><ul class='facets__list list-unstyled' role='list'>" +
      items.join('') +
      '</ul></div>';
    return groupShell(group.handle, group.title, body, 'filter-group--' + group.handle);
  }

  // Rows come from the values present in scope, not from a fixed list of single finishes.
  function comboGroupMarkup(group) {
    const values = engine
      .comboValues(buildQuery(), group.facet)
      .sort((a, b) => a.label.localeCompare(b.label));
    const picked = state.lists[group.facet];
    const items = [];
    values.forEach((value) => {
      const key = slug(value.label);
      const active = picked ? picked.has(key) : false;
      if (value.count === 0 && !active) {
        return;
      }
      items.push(listValueMarkup(group, group.facet, { key: key, label: value.label }, items.length + 1));
    });
    if (items.length === 0) {
      return '';
    }
    const body =
      "<div class='filter-items'><ul class='facets__list list-unstyled' role='list'>" +
      items.join('') +
      '</ul></div>';
    return groupShell(group.handle, group.title, body, 'filter-group--' + group.handle);
  }

  function listGroupMarkup(group, counts) {
    const facet = engine.facetByKey.get(group.facet);
    if (!facet) {
      return '';
    }
    const tally = counts[group.facet] || {};
    const picked = state.lists[group.facet];
    const items = [];
    (facet.values || []).forEach((value) => {
      const active = picked ? picked.has(value.key) : false;
      // A value nothing can reach is dropped, the same as the old Liquid panel.
      if ((tally[value.key] || 0) === 0 && !active) {
        return;
      }
      items.push(listValueMarkup(group, group.facet, value, items.length + 1));
    });
    if (items.length === 0) {
      return '';
    }
    const body =
      "<div class='filter-items'><ul class='facets__list list-unstyled' role='list'>" +
      items.join('') +
      '</ul></div>';
    return groupShell(group.handle, group.title, body, 'filter-group--' + group.handle);
  }

  function rangeGroupMarkup(group, counts) {
    const rows = group.rows
      .map((row) => {
        const span = counts[row.key];
        if (!span || span.count === 0) {
          return '';
        }
        return rangeRow(row, state.ranges[row.key], span);
      })
      .filter((markup) => markup !== '')
      .join('');
    if (rows === '') {
      return '';
    }
    const isDimension = group.handle !== 'beam-angle';
    const body = isDimension ? rows : "<div class='filter-items'>" + rows + '</div>';
    const className = isDimension
      ? 'filter-group__dimension ' + group.handle
      : 'filter-group--' + group.handle;
    return groupShell(group.handle, group.title, body, className);
  }

  // Brightness has its own layout, with the rings and one row reading MIN to MAX.
  function brightnessGroupMarkup(group, counts) {
    const span = counts[group.brightness];
    if (!span || span.count === 0) {
      return '';
    }
    const bounds = state.ranges[group.brightness] || { min: null, max: null };
    const value = (side) => (bounds[side] === null || bounds[side] === undefined ? '' : bounds[side]);
    const body =
      "<div class='filter-items'>" +
      "<div class='filter-group__range " + group.brightness + "' data-key='" + group.brightness + "'" +
      (span.min !== null ? " data-min-value='" + span.min + "'" : '') +
      (span.max !== null ? " data-max-value='" + span.max + "'" : '') +
      '>' +
      "<div class='filter-group-image'>" + BRIGHTNESS_RINGS + '</div>' +
      "<div class='filter-group__range-box'><div class='frame-range frame-range--bounded'>" +
      "<div class='text-wrapper text-wrapper--bound'>MIN</div>" +
      "<div class='filter-group__range__wrapper'>" +
      "<input type='text' inputmode='decimal' class='filter-group__range__input min' placeholder='--'" +
      " data-range='" + group.brightness + "' data-bound='min' value='" + value('min') + "'>" +
      '</div>' +
      "<div class='text-wrapper text-wrapper--bound text-wrapper--max'>MAX</div>" +
      "<div class='filter-group__range__wrapper'>" +
      "<input type='text' inputmode='decimal' class='filter-group__range__input max' placeholder='--'" +
      " data-range='" + group.brightness + "' data-bound='max' value='" + value('max') + "'>" +
      '</div>' +
      "<div class='text-wrapper'>" + escapeHtml(group.unit) + '</div>' +
      '</div></div></div></div>';
    return groupShell(group.handle, group.title, body, 'filter-group--' + group.handle);
  }

  function groupMarkup(group, counts) {
    if (group.bands) {
      return bandGroupMarkup(group);
    }
    if (group.combined) {
      return comboGroupMarkup(group);
    }
    if (group.facet) {
      return listGroupMarkup(group, counts);
    }
    if (group.brightness) {
      return brightnessGroupMarkup(group, counts);
    }
    if (group.rows) {
      return rangeGroupMarkup(group, counts);
    }
    return '';
  }

  function orderedGroups() {
    const refs = String(CONFIG.groups || DEFAULT_ORDER).split(',');
    const out = [];
    refs.forEach((ref) => {
      const group = GROUPS[ref.trim().toLowerCase()];
      if (!group) {
        return;
      }
      if (group.siblings) {
        group.siblings.forEach((sibling) => out.push(sibling));
        return;
      }
      out.push(group);
    });
    return out;
  }

  function chipMarkup() {
    const chips = [];
    Object.keys(state.lists).forEach((facetKey) => {
      const facet = engine.facetByKey.get(facetKey);
      state.lists[facetKey].forEach((valueKey) => {
        const combined = COMBINED[facetKey] ? comboLabelFor(facetKey, valueKey) : null;
        const value = combined
          ? { label: combined }
          : (facet && (facet.values || []).find((entry) => entry.key === valueKey)) || null;
        chips.push(
          "<li class='" + facetKey + "'><facet-remove>" +
          "<a href='#' data-remove-list='" + facetKey + "' data-remove-value='" + escapeHtml(valueKey) + "'" +
          " class='active-facets__button active-facets__button--light'>" +
          escapeHtml(value ? value.label : valueKey) + ICON_CLOSE +
          "<span class='visually-hidden'>Remove filter</span></a></facet-remove></li>"
        );
      });
    });
    Object.keys(state.bands).forEach((facetKey) => {
      const group = BANDED[facetKey];
      state.bands[facetKey].forEach((bandKey) => {
        const band = group ? group.bands.find((entry) => entry.key === bandKey) : null;
        chips.push(
          "<li class='" + facetKey + "'><facet-remove>" +
          "<a href='#' data-remove-band='" + facetKey + "' data-remove-value='" + escapeHtml(bandKey) + "'" +
          " class='active-facets__button active-facets__button--light'>" +
          escapeHtml(band ? band.label : bandKey) + ICON_CLOSE +
          "<span class='visually-hidden'>Remove filter</span></a></facet-remove></li>"
        );
      });
    });
    Object.keys(state.ranges).forEach((key) => {
      const facet = engine.facetByKey.get(key);
      const label = (facet ? facet.label : key).toUpperCase();
      chips.push(
        "<li><facet-remove>" +
        "<a href='#' data-remove-range='" + key + "'" +
        " class='active-facets__button active-facets__button--light'>" +
        escapeHtml(label) + ICON_CLOSE +
        "<span class='visually-hidden'>Remove filter</span></a></facet-remove></li>"
      );
    });
    return chips.length === 0 ? '' : '<ul>' + chips.join('') + '</ul>';
  }

  function openGroups() {
    return Array.from(document.querySelectorAll('.filter-group.active'))
      .map((group) => group.dataset.key)
      .filter((key) => key);
  }

  function typingInRange() {
    const active = document.activeElement;
    return !!(active && active.matches && active.matches('.filter-group__range__input[data-range]'));
  }

  function reopen(keys) {
    keys.forEach((key) => {
      const group = el('.filter-group[data-key="' + key + '"]');
      if (!group) {
        return;
      }
      group.classList.add('active');
      const items = group.querySelector('.filter-group__items');
      if (items) {
        items.style.display = 'block';
      }
    });
  }

  // The rings fill in five steps, measuring the asked maximum against the brightest in reach.
  function updateBrightnessRings() {
    const container = el('.filter-group__range.lumens');
    if (!container) {
      return;
    }
    const circles = container.querySelectorAll('.brightness-circle');
    if (circles.length === 0) {
      return;
    }
    circles.forEach((circle) => circle.setAttribute('stroke', '#949494'));

    const maxInput = container.querySelector('.filter-group__range__input.max');
    const reachable = parseFloat(container.dataset.maxValue) || 0;
    const asked = parseFloat(maxInput ? maxInput.value : '');
    if (!maxInput || maxInput.value === '' || !reachable || isNaN(asked) || asked <= 0) {
      return;
    }

    const step = reachable / 5;
    let lit = 1;
    if (asked >= reachable) {
      lit = 5;
    } else if (asked >= step * 4) {
      lit = 4;
    } else if (asked >= step * 3) {
      lit = 3;
    } else if (asked >= step * 2) {
      lit = 2;
    }
    for (let level = 1; level <= lit; level += 1) {
      const circle = container.querySelector('.brightness-circle[data-level="' + level + '"]');
      if (circle) {
        circle.setAttribute('stroke', '#FFFFFF');
      }
    }
  }

  function renderGroups(counts) {
    const grid = el('[data-sa-filters]');
    if (!grid) {
      return;
    }
    const keys = openGroups();
    grid.innerHTML = orderedGroups()
      .map((group) => groupMarkup(group, counts))
      .join('');
    reopen(keys);
    updateBrightnessRings();
    if (document.body.classList.contains('filters-popup--show')) {
      loadVisibleImages(grid);
    }
  }

  // Chips and the badge sit outside the groups, so these never disturb a field being typed in.
  function renderChips() {
    const chips = el('.filters-popup__active-filters');
    if (chips) {
      chips.innerHTML = chipMarkup();
    }
    const count = appliedCount();
    document.querySelectorAll('.js-applied-badge').forEach((badge) => {
      const slot = badge.querySelector('.filters-popup__applied-count');
      if (slot) {
        slot.textContent = count > 0 ? String(count) : '';
      }
      badge.hidden = count === 0;
    });
  }

  // ---------------------------------------------------------------- grid

  // The section writes each merchandising card to a template, with the position it follows.
  function readFeatured() {
    return Array.from(document.querySelectorAll('template[data-sa-featured]'))
      .map((node) => ({ after: Number(node.dataset.after), html: node.innerHTML }))
      .filter((card) => card.after > 0);
  }

  function paginationMarkup(page, pages) {
    if (pages < 2) {
      return '';
    }
    const wanted = [1, pages];
    for (let n = page - 2; n <= page + 2; n += 1) {
      if (n >= 1 && n <= pages) {
        wanted.push(n);
      }
    }
    const numbers = Array.from(new Set(wanted)).sort((a, b) => a - b);

    const parts = [];
    let previous = 0;
    numbers.forEach((number) => {
      if (previous !== 0 && number - previous > 1) {
        parts.push("<li><span class='pagination__item'>&hellip;</span></li>");
      }
      previous = number;
      if (number === page) {
        parts.push(
          "<li><a role='link' aria-disabled='true' class='pagination__item pagination__item--current light'" +
          " aria-current='page' aria-label='Page " + number + "'>" +
          "<span class='button__label'>" + number + '</span></a></li>'
        );
        return;
      }
      const params = new URLSearchParams(stateToSearch().split('?')[1] || '');
      if (number > 1) {
        params.set('page', String(number));
      } else {
        params.delete('page');
      }
      const search = params.toString();
      parts.push(
        "<li><a href='" + escapeHtml(window.location.pathname + (search === '' ? '' : '?' + search)) + "'" +
        " class='pagination__item link' data-page='" + number + "' aria-label='Page " + number + "'>" +
        "<span class='button__label'>" + number + '</span></a></li>'
      );
    });

    return (
      "<div class='pagination-wrapper'><nav class='pagination' role='navigation' aria-label='Pagination'>" +
      "<ul class='pagination__list list-unstyled' role='list'>" + parts.join('') + '</ul></nav></div>'
    );
  }

  function cardConfig() {
    const wide = (CONFIG.wideTags || []).length > 0;
    return {
      collection: wide ? null : CONFIG.collection || null,
      moneyFormat: CONFIG.moneyFormat,
      customerId: CONFIG.customerId,
      shopDomain: CONFIG.shopDomain,
      discount: CONFIG.discount || null
    };
  }

  // Merchandising cards only sit on the first page.
  function gridHtml(items, renderCard, wrapperClass, page) {
    const config = cardConfig();
    const cards = page === 1 ? featured : [];
    const out = [];
    items.forEach((product, at) => {
      out.push("<div class='" + wrapperClass + "'>" + renderCard(product, index, config) + '</div>');
      cards.forEach((card) => {
        if (card.after === at + 1) {
          out.push(card.html);
        }
      });
    });
    return out.join('');
  }

  // A lazy image added after load waits for the page to paint, so visible ones are asked for now.
  function loadVisibleImages(container) {
    if (!container) {
      return;
    }
    const reach = window.innerHeight * 1.5;
    container.querySelectorAll('img[loading="lazy"]').forEach((image) => {
      const box = image.getBoundingClientRect();
      if (box.bottom > -reach && box.top < reach) {
        image.setAttribute('loading', 'eager');
      }
    });
  }

  const NO_RESULTS =
    "<div class='collection-products__no-result'>" +
    "<p>No Results <span class='blinker'></span></p>" +
    '<h2>Please remove or reset filters to view available products.</h2></div>';

  function renderGrid(result) {
    const grid = el('.collection-products__grid');
    const list = el('.collection-products__list');

    if (grid) {
      grid.innerHTML =
        (result.items.length === 0
          ? NO_RESULTS
          : gridHtml(result.items, window.SACatalogCard.render, 'featured_layout-1', result.page)) +
        "<div id='ProductCount' style='display: none;'>" + result.items.length + '</div>';
    }
    if (list) {
      list.innerHTML =
        (result.items.length === 0
          ? NO_RESULTS
          : gridHtml(result.items, window.SACatalogCard.renderListCard, 'featured_layout-2', result.page)) +
        "<div id='ProductCount' style='display: none;'>" + result.items.length + '</div>';
    }

    const pagination = paginationMarkup(result.page, result.pages);
    document.querySelectorAll('.collection-products__load-more').forEach((slot) => {
      slot.innerHTML = pagination;
    });

    const total = el('.collection-products__count');
    if (total) {
      total.textContent = result.total + ' Products';
    }

    document.querySelectorAll('.collection-products__grid-wrapper, .collection-products__list-wrapper').forEach((wrapper) => {
      wrapper.classList.add('show');
    });

    loadVisibleImages(grid);
    loadVisibleImages(list);
  }

  function restoreServerGrid() {
    const grid = el('.collection-products__grid');
    const list = el('.collection-products__list');
    if (grid && serverGrid !== null) {
      grid.innerHTML = serverGrid;
    }
    if (list && serverList !== null) {
      list.innerHTML = serverList;
    }
    if (serverPaging !== null) {
      document.querySelectorAll('.collection-products__load-more').forEach((slot, at) => {
        slot.innerHTML = serverPaging[at] === undefined ? '' : serverPaging[at];
      });
    }
    const total = el('.collection-products__count');
    if (total && serverCount !== null) {
      total.textContent = serverCount;
    }
    loadVisibleImages(grid);
    loadVisibleImages(list);
  }

  // ---------------------------------------------------------------- apply

  function apply(options) {
    const query = buildQuery();

    // Redrawing the groups would replace the field being typed in, so they wait for focus to leave.
    if (typingInRange()) {
      groupsStale = true;
      renderChips();
    } else {
      renderGroups(engine.counts(query));
      renderChips();
      groupsStale = false;
    }

    // The grid is shown first, because a card added to a hidden one never loads its image.
    document.documentElement.classList.remove(PENDING_CLASS);

    // The url is written even with nothing filtered, so it always matches the page.
    if (options && options.push) {
      window.history.pushState({ saCatalog: true }, '', stateToSearch());
    }

    if (!isFiltered()) {
      restoreServerGrid();
      return;
    }

    const hits = engine.sort(engine.run(query), state.sort);
    renderGrid(engine.page(hits, state.page, CONFIG.perPage || 24));
  }

  function changed() {
    state.page = 1;
    apply({ push: true });
  }

  // ---------------------------------------------------------------- events

  function onCheckboxChange(input) {
    const facetKey = input.dataset.facet;
    const value = input.value;
    const picked = state.lists[facetKey] || new Set();
    if (input.checked) {
      picked.add(value);
    } else {
      picked.delete(value);
    }
    if (picked.size === 0) {
      delete state.lists[facetKey];
    } else {
      state.lists[facetKey] = picked;
    }
    changed();
  }

  function onBandChange(input) {
    const facetKey = input.dataset.band;
    const picked = state.bands[facetKey] || new Set();
    if (input.checked) {
      picked.add(input.value);
    } else {
      picked.delete(input.value);
    }
    if (picked.size === 0) {
      delete state.bands[facetKey];
    } else {
      state.bands[facetKey] = picked;
    }
    changed();
  }

  function onRangeInput(input) {
    const key = input.dataset.range;
    const bound = input.dataset.bound;
    const raw = input.value.trim().replace(/\.$/, '');
    const bounds = state.ranges[key] || { min: null, max: null };
    const number = Number(raw);
    bounds[bound] = raw === '' || isNaN(number) ? null : number;
    if (bounds.min === null && bounds.max === null) {
      delete state.ranges[key];
    } else {
      state.ranges[key] = bounds;
    }
    changed();
  }

  function bind() {
    document.addEventListener('change', (event) => {
      const input = event.target.closest('.filters-popup input[type="checkbox"][data-facet]');
      if (input) {
        onCheckboxChange(input);
        return;
      }
      const band = event.target.closest('.filters-popup input[type="checkbox"][data-band]');
      if (band) {
        onBandChange(band);
      }
    });

    // Debounced, so a three digit number runs one search and not three.
    document.addEventListener('input', (event) => {
      const input = event.target.closest('.filter-group__range__input[data-range]');
      if (!input) {
        return;
      }
      updateBrightnessRings();
      window.clearTimeout(typingTimer);
      typingTimer = window.setTimeout(() => onRangeInput(input), TYPING_DELAY);
    });

    // Focus has left, so the counts held back during typing can be drawn.
    document.addEventListener('focusout', (event) => {
      if (!event.target.closest || !event.target.closest('.filter-group__range__input[data-range]')) {
        return;
      }
      window.setTimeout(() => {
        if (groupsStale && engine && !typingInRange()) {
          renderGroups(engine.counts(buildQuery()));
          groupsStale = false;
        }
      }, 0);
    });

    document.addEventListener('click', (event) => {
      const listChip = event.target.closest('[data-remove-list]');
      if (listChip) {
        event.preventDefault();
        const facetKey = listChip.dataset.removeList;
        const picked = state.lists[facetKey];
        if (picked) {
          picked.delete(listChip.dataset.removeValue);
          if (picked.size === 0) {
            delete state.lists[facetKey];
          }
        }
        changed();
        return;
      }

      const bandChip = event.target.closest('[data-remove-band]');
      if (bandChip) {
        event.preventDefault();
        const facetKey = bandChip.dataset.removeBand;
        const picked = state.bands[facetKey];
        if (picked) {
          picked.delete(bandChip.dataset.removeValue);
          if (picked.size === 0) {
            delete state.bands[facetKey];
          }
        }
        changed();
        return;
      }

      const rangeChip = event.target.closest('[data-remove-range]');
      if (rangeChip) {
        event.preventDefault();
        delete state.ranges[rangeChip.dataset.removeRange];
        changed();
        return;
      }

      const clearAll = event.target.closest('[data-clear-all]');
      if (clearAll) {
        event.preventDefault();
        state = { lists: {}, ranges: {}, bands: {}, page: 1, sort: state.sort };
        apply({ push: true });
        return;
      }

      const pageLink = event.target.closest('.pagination__item[data-page]');
      if (pageLink) {
        event.preventDefault();
        state.page = Number(pageLink.dataset.page);
        apply({ push: true });
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });

    window.addEventListener('popstate', () => {
      state = readState(window.location.search);
      apply({ push: false });
    });
  }

  // ---------------------------------------------------------------- boot

  function stash() {
    const grid = el('.collection-products__grid');
    const list = el('.collection-products__list');
    serverGrid = grid ? grid.innerHTML : null;
    serverList = list ? list.innerHTML : null;
    serverPaging = Array.from(document.querySelectorAll('.collection-products__load-more')).map(
      (slot) => slot.innerHTML
    );
    const total = el('.collection-products__count');
    serverCount = total ? total.textContent : null;
    featured = readFeatured();
  }

  function start() {
    if (loader) {
      return loader;
    }
    loader = window.SACatalogIndex.load({ proxy: CONFIG.proxy })
      .then((result) => {
        index = result.index;
        engine = window.SACatalogEngine.create(index);
        state = readState(window.location.search);
        bind();
        apply({ push: false });
        return result;
      })
      .catch((error) => {
        // With no index there is nothing to filter, so the grid Liquid rendered stays.
        document.documentElement.classList.remove(PENDING_CLASS);
        if (!error.notBuilt) {
          console.warn('[sa-catalog] filter index unavailable', error);
        }
        throw error;
      });
    return loader;
  }

  function boot() {
    if (!el('.filters-popup')) {
      return;
    }
    stash();

    if (CONFIG.discount && CONFIG.discount.unresolved) {
      console.warn('[sa-catalog] a discount collection could not be matched to a handle, applying it to every product');
      CONFIG.discount.collections = [];
      CONFIG.discount.variants = [];
    }

    if (hasFilterParams(window.location.search)) {
      start();
    } else if (window.requestIdleCallback) {
      window.requestIdleCallback(() => start(), { timeout: 4000 });
    } else {
      window.setTimeout(start, 1200);
    }

    // Opening the panel before the idle pass still needs the index, so ask for it then too.
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.js-filters-popup__open')) {
        return;
      }
      start()
        .then(() => loadVisibleImages(el('[data-sa-filters]')))
        .catch(() => {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

